import { PROMO_CAROUSEL_CTAS } from 'src/shared/static';
import { C07PromoCTAProps } from '../C07PromoCTA/C07PromoCTA.types';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C06PromoCarouselCTAProps = RenderingProps<
  undefined,
  {
    SlideTiming?: string;
    ImageSide?: string;
    BackgroundColor?: string;
    SecondCTAStyle?: string;
    TextAlignment?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams,
  {
    [PROMO_CAROUSEL_CTAS]?: Array<C07PromoCTAProps['rendering']>;
  }
>;
